import { render } from "./BtnAtualizarAtendimentoDetalhe.vue?vue&type=template&id=166c20f6"
import script from "./BtnAtualizarAtendimentoDetalhe.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarAtendimentoDetalhe.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__